import React, { forwardRef } from 'react';
import { Bar } from 'react-chartjs-2';

const mergeEmEquities = (items) => {
  const merged = [];
  let intlIdx = -1;
  items.forEach(d => {
    const name = d.asset_class === 'EM Equities' ? 'International Equities' : d.asset_class;
    const existing = merged.findIndex(m => m.asset_class === name);
    if (existing !== -1) {
      merged[existing] = { ...merged[existing], active_tilt: (merged[existing].active_tilt || 0) + (d.active_tilt || 0) };
    } else {
      merged.push({ ...d, asset_class: name });
    }
  });
  return merged;
};

const ActiveTiltsChart = forwardRef(({ data, colours = {} }, ref) => {
  if (!data || data.length === 0) {
    return <div className="chart-placeholder">No active tilt data available</div>;
  }

  const posFill = colours.tilt_positive_fill || '#337B91';
  const negFill = colours.tilt_negative_fill || '#ffffff';
  const borderClr = colours.tilt_border || '#337B91';

  const merged = mergeEmEquities(data);
  const labels = merged.map(d => d.asset_class);
  const values = merged.map(d => d.active_tilt);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Active Tilt',
        data: values,
        backgroundColor: values.map(v => v >= 0 ? posFill : negFill),
        borderColor: borderClr,
        borderWidth: 1,
        barPercentage: 0.85,
        categoryPercentage: 0.95,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.x > 0 ? '+' : ''}${ctx.parsed.x.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: {
          font: { size: 10 },
          callback: (val) => `${val > 0 ? '+' : ''}${val}%`,
        },
      },
      y: {
        border: { display: false },
        grid: { display: false },
        ticks: { font: { size: 10 } },
      },
    },
  };

  return (
    <div style={{ height: `${Math.max(80, data.length * 22)}px` }}>
      <Bar ref={ref} data={chartData} options={options} />
    </div>
  );
});

ActiveTiltsChart.displayName = 'ActiveTiltsChart';
export default ActiveTiltsChart;
